import gql from 'graphql-tag';

export default gql`
  mutation groupMemberRemove($input: GroupMemberRemoveInput!) {
    groupMemberRemove(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
